import { Helmet } from 'react-helmet';

const AdminHelmet = () => (
  <Helmet>
    <title>supervise admin</title>
  </Helmet>
);

export default AdminHelmet;